import { lexiconSharedActionCreators } from 'src/containers/Lexicon/shared-actions/lexicon-shared-actions';

export const deepTagReportsContainerSwitchActions = {
  getLexiconsMetadataList: lexiconSharedActionCreators.getLexiconMetadata(
    'DeepTagReportsContainerSwitch/GetLexiconsMetadataList'
  ),
};
